/**
 * Converte URLs em texto puro dentro de HTML em links clicáveis (<a>).
 * Ignora URLs que já estão dentro de tags <a>.
 */
export function linkifyHtml(html: string): string {
  if (!html) return "";

  // Regex para URLs que começam com http:// ou https://
  const urlRegex = /(https?:\/\/[^\s<>"')\]]+)/gi;

  // Dividir o HTML em partes: dentro de tags e fora de tags
  // Para não converter URLs que já estão em href="..."
  const parts = html.split(/(<a\s[^>]*>.*?<\/a>|<[^>]+>)/gi);

  const result = parts.map((part) => {
    // Se é uma tag HTML ou um link existente, não mexe
    if (part.startsWith("<")) {
      return part;
    }

    // É texto puro — converte URLs em links clicáveis
    return part.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  });

  return result.join("");
}
